// Prix partagé : le prix du cours est divisé entre tous les inscrits.
// Seul·e, on paie le prix total ; à chaque nouvel inscrit, la part de chacun
// baisse et les élèves déjà inscrits sont remboursés de la différence.

/** Arrondi au centime */
export const round2 = (x) => Math.round(Number(x) * 100) / 100;

/** Part de chaque élève quand `n` élèves sont inscrits */
export const sharePrice = (price, n) => round2(Number(price) / Math.max(1, Number(n) || 1));

/** Ce que paie la personne qui s'inscrit maintenant (elle devient la n+1-ième) */
export const priceIfIJoin = (course) => sharePrice(course.price, (Number(course.students) || 0) + 1);

/** Prix minimum par élève (cours complet) */
export const minSharePrice = (course) => sharePrice(course.price, course.maxStudents);

const COIN_WORDS = {
  fr: ["pièce", "pièces"],
  nl: ["munt", "munten"],
  en: ["coin", "coins"],
};

/** « 1 pièce », « 10 pièces », « 3,33 pièces » (ou munten / coins selon la langue) */
export const formatPieces = (x, lang = "fr") => {
  const n = round2(x);
  const sep = lang === "en" ? "." : ",";
  const txt = Number.isInteger(n) ? String(n) : n.toFixed(2).replace(".", sep);
  const [one, many] = COIN_WORDS[lang] || COIN_WORDS.fr;
  const plural = lang === "fr" ? Math.abs(n) >= 2 : Math.abs(n) !== 1;
  return `${txt} ${plural ? many : one}`;
};

// Commission Tatie Soso, prélevée sur ce que reçoit le prof (pas sur les élèves)
export const COMMISSION_RATE = 0.1;

/** Répartition d'un montant encaissé : part du prof et commission */
export const splitPayout = (collected) => {
  const total = round2(collected);
  const commission = round2(total * COMMISSION_RATE);
  return { total, commission, prof: round2(total - commission) };
};
